import {
  ADD_SUB_CATEGORY_REQUEST,
  SUB_CATEGORIES_LIST_REQUEST,
  SUB_CATEGORIES_LIST_RESPONSE,
  EDIT_SUB_CATEGORY_REQUEST,
  GET_SUB_CATEGORY_DETAILS_REQUEST,
  GET_SUB_CATEGORY_DETAILS_RESPONSE,
  DELETE_SUB_CATEGORY_REQUEST,
  SUB_CATEGORY_PRODUCTS_LIST_REQUEST,
  SUB_CATEGORY_PRODUCTS_LIST_RESPONSE
} from "./types";

export const subCategoriesListRequest = (payload) => ({
  type: SUB_CATEGORIES_LIST_REQUEST,
  payload
});

export const subCategoriesListResponse = (payload) => ({
  type: SUB_CATEGORIES_LIST_RESPONSE,
  payload
});

export const addSubCategoryRequest = (payload) => ({
  type: ADD_SUB_CATEGORY_REQUEST,
  payload
});

export const editSubCategoryRequest = (payload) => ({
  type: EDIT_SUB_CATEGORY_REQUEST,
  payload
});

export const getSubCategoryDetailsRequest = (payload) => ({
  type: GET_SUB_CATEGORY_DETAILS_REQUEST,
  payload
});

export const getSubCategoryDetailsResponse = (payload) => ({
  type: GET_SUB_CATEGORY_DETAILS_RESPONSE,
  payload
});

export const subCategoryProductsListRequest = (payload) => ({
  type: SUB_CATEGORY_PRODUCTS_LIST_REQUEST,
  payload
});

export const subCategoryProductsListResponse = (payload) => ({
  type: SUB_CATEGORY_PRODUCTS_LIST_RESPONSE,
  payload
});

export const deleteSubCategoryRequest = (payload) => ({
  type: DELETE_SUB_CATEGORY_REQUEST,
  payload
});
